import "./Home.module.css";
import CabeceraPrincipal from "@/reusable_sections/Header";
import ConectividadSinLMites from "./sections/ConectividadSinLMites";
import EcosistemaDeSoluciones from "./sections/EcosistemaDeSoluciones";
import ImpulseSuComunicaciN from "./sections/ImpulseSuComunicaciN";
import TecnologAGrandstream from "./sections/TecnologAGrandstream";
import AgendeUnaAsesorA from "./sections/AgendeUnaAsesorA";
import Contactinformation from "./sections/Contactinformation";
import ResumenServicios from "./sections/ResumenServicios";
import PieDePGinaInformativo from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <CabeceraPrincipal />
      {}
      <ConectividadSinLMites />
      
      {}
      <ResumenServicios />
      
      {}
      <EcosistemaDeSoluciones />
      
      {}
      <ImpulseSuComunicaciN />
      
      {}
      <TecnologAGrandstream />
      
      {}
      <AgendeUnaAsesorA />
      <Contactinformation />
      
      <PieDePGinaInformativo />
    </div>;
}